module.exports = __webpack_public_path__ + "media/images/crm/icon-chart-4f0b34d7438460e9f3cea8ef691c7843.png";